import { locationsApi } from "@src/service/locations";
import { getRequestError } from "@src/utils/getRequestError";

import { put, call, takeLatest, select, take } from "redux-saga/effects";
import { setGlobalLoader, setSnackbar } from "../generals/actionCreators";
import { LoadingStatus } from "../generals/types";
import {
  fetchCashSystem,
  fetchLocations,
  fetchOrganizations,
  fetchPaymentTypes,
} from "./actionCreators";
import {
  CREATE_GLOVO_INTEGRATION,
  FETCH_LOCATIONS_SAGA,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_ORGANIZATIONS,
  FETCH_ORGANIZATIONS_ERROR,
  FETCH_ORGANIZATIONS_SUCCESS,
  FETCH_ORGANIZATION_SAGA,
  SEND_IIKO_ORGANIZATIONS_SAGA,
  SEND_IIKO_ORGANIZATIONS_SUCCESS,
  SWITCH_LOCATION_INTEGRATION_MODE,
  FETCH_PAYMENT_TYPES_SAGA,
  FETCH_PAYMENT_TYPES,
  FETCH_PAYMENT_TYPES_ERROR,
  FETCH_PAYMENT_TYPES_SUCCESS,
  CREATE_GLOVO_INTEGRATION_SUCCESS,
  GET_LOCATION_BY_ID_SUCCESS,
  GET_LOCATION_BY_ID_SAGA,
  EDIT_LOCATION_ITEM_SAGA,
  SET_NEXT_IN_PROGRESS_LOADER,
  DELETE_LOCATION_SAGA,
  FETCH_CASH_SYSTEM_SUCCESS,
  FETCH_CASH_SYSTEM_SAGA,
  SET_LOCATION_DRAWER_LOADING,
  EDIT_CASH_SYSTEM_SAGA,
  PATCH_INTEGRATION_SAGA,
  GET_LANGUAGES_SAGA,
  GET_CURRENCIES_SAGA,
  GET_CURRENCIES_SUCCESS,
  GET_LANGUAGES_SUCCESS,
  CREATE_WOLT_INTEGRATION_SAGA,
  GET_AGGREGATOR_DATA_SUCCESS,
  GET_AGGREGATOR_DATA_SAGA,
  FETCH_ORDER_TYPES_SUCCESS,
  FETCH_ORDER_TYPES_SAGA,
  UPDATE_AGGREGATOR_DATA_SAGA,
  GET_POS_IDS_SAGA,
  GET_POS_IDS_SUCCESS,
  GET_YANDEX_CREDENTIALS_SAGA,
  GET_YANDEX_CREDENTIALS_SUCCESS,
  CREATE_YANDEX_INTEGRATION_SAGA,
  GET_USER_LIST_SUCESS,
  GET_USER_LIST_SAGA,
  EDIT_CHECK_FIELDS_SAGA,
} from "./types/actionTypes";

export function* fetchLocationsRequest(action: any): any {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    const restaurant_group_id = localStorage.getItem("currRestGroupId");

    let query = `&rst_group_id=${restaurant_group_id}`;
    // sorting
    if (action.payload.field) {
      query += `&sort_by=${action.payload.field}&sort_order=${action.payload.direction}`;
    } // SEARCH
    if (action.payload.q) {
      query += `&q=${action.payload.q}`;
    }

    const { data } = yield call(
      locationsApi.getLocations,
      action.payload,
      query
    );

    yield put({ type: FETCH_LOCATIONS_SUCCESS, payload: data });
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e: any) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}
export function* getLocationByIdRequest(action: any) {
  try {
    const { data } = yield call(locationsApi.getLocationById, action.payload);
    yield put({ type: GET_LOCATION_BY_ID_SUCCESS, payload: data.restaurant });
  } catch (e: any) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* getUserListRequest() {
  try {
    const { data } = yield call(locationsApi.getUserList);
    yield put({ type: GET_USER_LIST_SUCESS, payload: data });
  } catch (e) {
    setSnackbar({
      visible: true,
      status: "error",
      message: getRequestError(e),
    });
  }
}

export function* deleteLocationRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    yield call(locationsApi.deleteLocations, action.payload.resti_id);
    yield put(
      setSnackbar({
        visible: true,
        status: "success",
        message: "Местоположение удалено",
      })
    );
    yield put(fetchLocations(action.payload.page));
    // yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* fetchLanguagesRequest() {
  try {
    const { data } = yield call(locationsApi.getLanguages);

    yield put({ type: GET_LANGUAGES_SUCCESS, payload: data });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* editChecksFieldRequest(action: any) {
  try {
    yield call(locationsApi.editChecksField, action.payload);
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* fetchCurrenciesRequest() {
  try {
    const { data } = yield call(locationsApi.getCurrencies);

    yield put({ type: GET_CURRENCIES_SUCCESS, payload: data.data });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* fetchAggregatorDataRequest(action: any) {
  try {
    const { resti_id, aggregator } = action.payload;

    yield put(fetchPaymentTypes(resti_id));

    const { data } = yield call(
      locationsApi.getAggregatorData,
      resti_id,
      aggregator
    );

    yield put({ type: GET_AGGREGATOR_DATA_SUCCESS, payload: data });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
    yield put({ type: GET_AGGREGATOR_DATA_SUCCESS, payload: {} });
  }
}

export function* fetchTerminalsRequest(action: any): any {
  try {
    yield put({ type: FETCH_ORGANIZATIONS });
    const { api_login, pos_type } = action.payload;
    const { data } = yield call(
      locationsApi.get_orgnizations,
      api_login,
      pos_type
    );

    yield put({ type: FETCH_ORGANIZATIONS_SUCCESS, payload: data });
  } catch (e: any) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: e.response ? e.response.message : "Network Error",
      })
    );
    yield put({ type: FETCH_ORGANIZATIONS_ERROR });
  }
}

export function* fetchPaymentTypesRequest(action: any): any {
  try {
    yield put({ type: FETCH_PAYMENT_TYPES });
    const { data } = yield call(locationsApi.getPaymentTypes, action.payload);
    yield put({ type: FETCH_PAYMENT_TYPES_SUCCESS, payload: data });
  } catch (e: any) {
    yield put({ type: FETCH_PAYMENT_TYPES_ERROR });
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* createGlovoIntegration(action: any): any {
  try {
    yield put({ type: SET_NEXT_IN_PROGRESS_LOADER, payload: true });

    const payload = { ...action.payload.data };
    yield call(locationsApi.createGlovoIntegration, payload);
    yield put(fetchLocations());
    yield put(
      setSnackbar({ visible: true, status: "success", message: "Успешно" })
    );
    yield put({
      type: CREATE_GLOVO_INTEGRATION_SUCCESS,
      payload: action.payload,
    });
  } catch (e: any) {
    yield put({ type: SET_NEXT_IN_PROGRESS_LOADER, payload: false });
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* createWoltIntegration(action: any): any {
  try {
    yield put({ type: SET_NEXT_IN_PROGRESS_LOADER, payload: true });

    const payload = { ...action.payload.data };
    yield call(locationsApi.createWoltIntegration, payload);
    yield put(fetchLocations());
    yield put(
      setSnackbar({ visible: true, status: "success", message: "Успешно" })
    );
    yield put({ type: SET_NEXT_IN_PROGRESS_LOADER, payload: false });
  } catch (e: any) {
    yield put({ type: SET_NEXT_IN_PROGRESS_LOADER, payload: false });
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* switchIntegration(action: any): any {
  try {
    const { location_id, is_active } = action.payload;
    const { page } = yield select((state) => state.locations);
    yield call(locationsApi.disableLocationIntegration, location_id, is_active);
    yield put(fetchLocations(page));
  } catch (e: any) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* createOrganizations(action: any): any {
  try {
    yield put({ type: SET_NEXT_IN_PROGRESS_LOADER, payload: true });

    const { data, navigate } = action.payload;

    yield call(locationsApi.createOrganizations, data);

    yield put({ type: SEND_IIKO_ORGANIZATIONS_SUCCESS });

    navigate(
      `/app/location/create-agregators/${data.pos_type}/${data.rest_id}`
    );

    // navigate(`/app/location/create-agregators/${data.rest_id}`);
  } catch (e: any) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
    yield put({ type: SET_NEXT_IN_PROGRESS_LOADER, payload: false });
  }
}
export function* getPosIdsRequest(action: any) {
  try {
    const { api_login, pos_type } = action.payload;
    const { data } = yield call(locationsApi.getPosIds, api_login, pos_type);

    yield put({ type: GET_POS_IDS_SUCCESS, payload: data });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}
// EDIT

export function* editLocationDataRequest(action: any) {
  try {
    const { restaurant_id, form, navigate } = action.payload;
    const { data } = yield call(
      locationsApi.editLocationData,
      restaurant_id,
      form
    );
    if (data) {
      yield put(
        setSnackbar({ visible: true, status: "success", message: "Updated !" })
      );
    }
    yield put(fetchLocations(1));
    navigate(`/app/location/edit-cash-system/${restaurant_id}`);
  } catch (e: any) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}
export function* fetchCashSystemRequest(action: any) {
  try {
    yield put({ type: SET_LOCATION_DRAWER_LOADING, payload: true });
    const { data } = yield call(locationsApi.getCashSystem, action.payload);
    yield put(fetchOrganizations(data.api_login, "iiko"));
    yield put({ type: FETCH_CASH_SYSTEM_SUCCESS, payload: data });
    yield put({ type: SET_LOCATION_DRAWER_LOADING, payload: false });
  } catch (e: any) {
    yield put({ type: SET_LOCATION_DRAWER_LOADING, payload: false });

    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}
export function* editCashSystemRequest(action: any) {
  try {
    const { terminals, resti_id, ...body } = action.payload;
    body["rest_id"] = String(resti_id).toLocaleLowerCase();
    yield call(locationsApi.editCashSystem, body);
    yield put(
      setSnackbar({ visible: true, status: "success", message: "Success" })
    );
  } catch (e: any) {
    yield put(
      setSnackbar({ visible: true, status: "error", message: "Success" })
    );
  }
}
export function* patchIntegrationRequest(action: any) {
  try {
    const { data } = yield call(locationsApi.patchIntegration, action.payload);
    yield put(
      setSnackbar({ visible: true, status: "success", message: "Success" })
    );
  } catch (e) {
    yield put(
      setSnackbar({ visible: true, status: "error", message: "Success" })
    );
  }
}
export function* fetchOrdersTypesRequest(action: any) {
  try {
    const restaurant_id = action.payload;
    const { data } = yield call(locationsApi.getOrderTypes, restaurant_id);

    yield put({
      type: FETCH_ORDER_TYPES_SUCCESS,
      payload: data?.[0]?.order_types,
    });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* updateAggregatorDataRequest(action: any) {
  try {
    const { data, aggregator } = action.payload;
    yield call(locationsApi.updateAggregatorData, data, aggregator);

    yield put(
      setSnackbar({ visible: true, status: "success", message: "Success" })
    );
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

// YANDEX

export function* getYandexCredentialsRequest(action: any) {
  try {
    const { data } = yield call(
      locationsApi.getYandexCredentials,
      action.payload
    );

    yield put({ type: GET_YANDEX_CREDENTIALS_SUCCESS, payload: data });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* createYandexIntegrationRequest(action: any) {
  try {
    yield call(locationsApi.createYandexIntegrations, action.payload);

    yield put(
      setSnackbar({ visible: true, status: "success", message: "Success" })
    );
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* locationsSaga() {
  yield takeLatest(FETCH_LOCATIONS_SAGA, fetchLocationsRequest);
  yield takeLatest(DELETE_LOCATION_SAGA, deleteLocationRequest);
  yield takeLatest(FETCH_ORGANIZATION_SAGA, fetchTerminalsRequest);
  yield takeLatest(FETCH_PAYMENT_TYPES_SAGA, fetchPaymentTypesRequest);
  yield takeLatest(SWITCH_LOCATION_INTEGRATION_MODE, switchIntegration);
  yield takeLatest(SEND_IIKO_ORGANIZATIONS_SAGA, createOrganizations);
  yield takeLatest(CREATE_GLOVO_INTEGRATION, createGlovoIntegration);
  yield takeLatest(GET_LOCATION_BY_ID_SAGA, getLocationByIdRequest);
  yield takeLatest(EDIT_LOCATION_ITEM_SAGA, editLocationDataRequest);
  yield takeLatest(CREATE_WOLT_INTEGRATION_SAGA, createWoltIntegration);

  yield takeLatest(FETCH_CASH_SYSTEM_SAGA, fetchCashSystemRequest);
  yield takeLatest(EDIT_CASH_SYSTEM_SAGA, editCashSystemRequest);
  yield takeLatest(PATCH_INTEGRATION_SAGA, patchIntegrationRequest);

  yield takeLatest(GET_CURRENCIES_SAGA, fetchCurrenciesRequest);
  yield takeLatest(GET_LANGUAGES_SAGA, fetchLanguagesRequest);

  yield takeLatest(GET_AGGREGATOR_DATA_SAGA, fetchAggregatorDataRequest);
  yield takeLatest(FETCH_ORDER_TYPES_SAGA, fetchOrdersTypesRequest);

  yield takeLatest(UPDATE_AGGREGATOR_DATA_SAGA, updateAggregatorDataRequest);

  yield takeLatest(GET_POS_IDS_SAGA, getPosIdsRequest);

  yield takeLatest(GET_YANDEX_CREDENTIALS_SAGA, getYandexCredentialsRequest);

  yield takeLatest(
    CREATE_YANDEX_INTEGRATION_SAGA,
    createYandexIntegrationRequest
  );

  yield takeLatest(GET_USER_LIST_SAGA, getUserListRequest);

  yield takeLatest(EDIT_CHECK_FIELDS_SAGA, editChecksFieldRequest);
}
